module.exports = {
  "version": "0.32.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 371
// module chunks = 0